module.exports = __webpack_public_path__ + "static/media/SpiritVessel.cd70b0d0.png";